import ScoutAvatar from '../ScoutAvatar'

import { getInitials } from '../../services/scout'

const ConversationAvatar = ({ conversation, displayName, className = 'scout-conversation-row__avatar' }) => {
	const title = displayName || 'Conversa'

	return (
		<ScoutAvatar
			entity={conversation}
			alt={title}
			className={className}
			fallback={() => <div className={className}>{getInitials(title)}</div>}
		/>
	)
}

export default ConversationAvatar